/**
 * @module monetization/display-mode
 *
 * Resolves a surface's on-return reminder behaviour from its presentation
 * blob. The widget itself is always shown and always opens the detail sheet on
 * tap — {@link DisplayMode} only controls the automatic nudge when the player
 * comes back to the lobby. See predictions-admin's `DISPLAY_MODES` for the
 * Ops-facing source of truth.
 */
import type { DisplayMode, SurfaceItem } from './types';

/** Matches predictions-admin's `DEFAULT_DISPLAY_MODE` — legacy / absent values
 *  behave as a full auto-popup. */
export const DEFAULT_DISPLAY_MODE: DisplayMode = 'FULL_POPUP';

const KNOWN: ReadonlySet<DisplayMode> = new Set(['ON_CLICK', 'FULL_POPUP', 'REMINDER']);

/** The surface's display mode, defaulting on an absent / unknown value. */
export function surfaceDisplayMode(item: SurfaceItem): DisplayMode {
  const raw = item.presentation?.displayMode;
  return typeof raw === 'string' && KNOWN.has(raw as DisplayMode) ? (raw as DisplayMode) : DEFAULT_DISPLAY_MODE;
}
